import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";

import Home from "./components/Home";
import MenShirts from "./components/MenShirts";
import WomenShirts from "./components/WomenShirts";
import KidsShirts from "./components/KidsShirts";
import TexturePaint from "./components/TexturePaint";
import ProductDetails from "./components/ProductDetails";
import CollectionPage from "./components/CollectionPage";
import CatalogProducts from "./components/CatalogProducts";
import Sale from "./components/Sale";
import StoriesList from "./components/StoriesList";

import Cart from "./components/Cart";
import About from "./components/About";
import CheckoutPage from "./components/CheckoutPage";

import ScrollToTop from "./components/ScrollToTop";
import Contact from "./components/Contact";

import "./styles/app.css";

import {
  BackgroundProvider,
  useBackground,
} from "./context/BackgroundProvider";

function App() {
const { theme } = useBackground();

  return (
    <div className="App" style={{ backgroundColor: theme.background }}>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Navigate to="/home" replace />} />
        <Route path="/home" element={<Home />} />
        <Route path="/men-shirts" element={<MenShirts />} />
        <Route path="/women-shirts" element={<WomenShirts />} />
        <Route path="/resin-art" element={<KidsShirts />} />
        <Route path="/texture-paint" element={<TexturePaint />} />
        <Route path="/about" element={<About />} />
        <Route path="/sale/:salepath" element={<Sale />} />
        <Route
          path="/collection/:collectionName"
          element={<CollectionPage />}
        />
        <Route
          path="/catalog/:catalogName/:collectionName"
          element={<CatalogProducts />}
        />
        <Route
          path="/product/:collectionName/:id"
          element={<ProductDetails />}
        />
        <Route path="/cart" element={<Cart />} />
        <Route path="/checkout/*" element={<CheckoutPage />} />
        <Route
          path="*"
          element={
            window.location.pathname.startsWith("/api/") ? null : (
              <Navigate to="/home" replace />
            )
          }
        />{" "}
        <Route path="/stories" element={<StoriesList />} />
      </Routes>
      <Contact />
    </div>
  );
}

export default function AppWrapper() {
  return (
    <Router>
      <BackgroundProvider>
        <App />
      </BackgroundProvider>
    </Router>
  );
}
